/* import __COLOCATED_TEMPLATE__ from './edit-mcp-server-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';

interface Args {
  onModalClose: () => void;
  mcpServer: McpServer;
  onDeleteMcpServerClick: () => void;
}

export default class EditMcpServerModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare store: $TSFixMe;

  get serverName() {
    return this.args.mcpServer.name || '';
  }

  get serverUrl() {
    return this.args.mcpServer.url || '';
  }

  get serverDescription() {
    return this.args.mcpServer.description || '';
  }

  get serverIcon() {
    return this.args.mcpServer.icon;
  }

  @action
  openDeleteMcpServerModal() {
    this.args.onModalClose();
    this.args.onDeleteMcpServerClick();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::EditMcpServerModal': typeof EditMcpServerModal;
    'workflow-connector/edit-mcp-server-modal': typeof EditMcpServerModal;
  }
}
